<template>
    <div class="quickrent-map__wrapper">
        <div ref="map" class="quickrent-map__map-container"></div>
        <div class="quickrent-map__overlay" v-if="showStation"></div>
        <div class="quickrent-map__overlay" v-if="loading">
            <div class="quickrent-map__loading-container">
                <div class="quickrent-map__loading-content">{{ loadingText }}</div>
            </div>
        </div>
    </div>
</template>

<script>
// import MarkerClusterer from '@google/markerclusterer';
import gmapsInit from '../utils/gmaps';
import CustomIcon from '@/img/pin.svg';

let currentLanguage = 'de';
const textsByLanguage = {
    de: {
        loading: 'Standort wird gesucht...',
        noStation: 'Keine Station gefunden',
    },
    en: {
        loading: 'Searching for station...',
        noStation: 'No station found',
    },
    fr: {
        loading: 'Recherche de station...',
        noStation: 'Aucune station trouvée',
    },
};

export default {
    props: ['lat', 'lng'],
    name: 'LocationComponent',
    methods: {
        close: function (e) {
            if (e.target.className === 'quickrent-map__overlay') {
                this.showStation = false;
            }
        },
        deleteMarkers: function () {
            for (let i = 0; i < this.markers.length; i++) {
                this.markers[i].setMap(null);
            }
        },
        renderLocations: async function (_lat, _lng) {
            try {
                this.loading = true;

                const position = {
                    lat: parseFloat(_lat),
                    lng: parseFloat(_lng),
                };

                let icon = CustomIcon;

                const marker = new this.google.maps.Marker({ position, map: this.map, icon: icon });
                this.markers = marker;

                this.map.setCenter(position);
                this.map.setZoom(13);

                this.initMarkerClusterer();
            } catch (e) {
                this.error = e;
            }
            this.loading = false;
        },
        initMarkerClusterer: function () {
            return;
            // new MarkerClusterer(this.map, this.markers, {
            //     maxZoom: 10,
            //     imagePath:
            //         'https://www.quickrent.ch/wp-content/themes/wpcarsharing_theme/dist/assets/img/neu/pin.png?z=',
            // });
        },
    },
    data: function () {
        return {
            showStation: false,
            loading: true,
            map: null,
            google: null,
            error: null,
            markers: [],
            vehicles: null,
            loadingText: textsByLanguage[currentLanguage].loading,
        };
    },
    async mounted() {
        try {
            const currentUrl = window.location.href.split('/');
            currentLanguage = currentUrl[3];

            if (currentLanguage !== 'en' && currentLanguage !== 'fr') {
                currentLanguage = 'de';
            }

            this.loadingText = textsByLanguage[currentLanguage].loading;
        } catch (error) {
            this.error = error;
        }

        try {
            this.google = await gmapsInit();
            const geocoder = new this.google.maps.Geocoder();
            this.map = new this.google.maps.Map(this.$refs['map'], {
                disableDefaultUI: true,
                zoomControl: true,
            });

            if (this.lat && this.lng) {
                this.renderLocations(this.lat, this.lng);
            } else {
                geocoder.geocode({ address: 'Bern' }, (results, status) => {
                    if (status !== 'OK' || !results[0]) {
                        throw new Error(status);
                    }

                    this.map.setCenter(results[0].geometry.location);
                    this.map.fitBounds(results[0].geometry.viewport);
                    this.map.setZoom(12);

                    this.loadingText = textsByLanguage[currentLanguage].noStation;
                });
            }
        } catch (error) {
            this.error = error;
            // console.error(error);
        }
    },
};
</script>

<style scoped>
.quickrent-map__wrapper {
    position: relative;
    width: 100%;
    height: 450px;
}

.quickrent-map__map-container {
    width: 100%;
    height: 450px;
}

.quickrent-map__overlay {
    width: 100%;
    height: 450px;
    background: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99;
}

.quickrent-map__loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 450px;
}

.quickrent-map__loading-content {
    /*flex: 0 0 300px;*/
    color: white;
    font-weight: bold;
}
</style>
